module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "title": "Edit Details",
      "settings": _vm.settings
    },
    on: {
      "save": _vm.saveRecord,
      "show": _vm.show
    }
  }, [_c('v-menu', {
    attrs: {
      "slot": "header",
      "offset-y": ""
    },
    slot: "header",
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menus), function(menu) {
    return _c('v-list-item', {
      key: menu.name,
      on: {
        "click": function($event) {
          return _vm.menuClicked(menu)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(menu.title))])], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-3"
  }, _vm._l((_vm.fields), function(field, index) {
    return _c('InterfaceField', {
      key: index,
      attrs: {
        "field": field,
        "record": _vm.record,
        "settings": {
          editing: false
        },
        "element": field
      }
    })
  }), 1), _vm._v(" "), (_vm.settings.deleteButton) ? _c('DeleteButton', {
    attrs: {
      "slot": "footer"
    },
    on: {
      "delete": _vm.deleteButtonClicked
    },
    slot: "footer"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b7e4c2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/AdvancedDialog.vue
// module id = 2565
// module chunks = 1